import { z } from 'zod';

import { ExportQSetFormat, QSetExportFileTemplate } from '../../constants';

export const QSetExportFormSchema = z.object({
  fileType: z.nativeEnum(ExportQSetFormat),
  template: z.nativeEnum(QSetExportFileTemplate),
});

export type QSetExportFormInput = z.infer<typeof QSetExportFormSchema>;
